import React, { useState } from 'react';
import { useCollection } from '../../hooks/useCollection';
import type { Video, Settings } from '../../types';
import VideoCard from '../../components/VideoCard';
import VideoModal from '../../components/VideoModal';
import { useSEO } from '../../hooks/useSEO';

const VideosPage: React.FC<{ settings: Settings }> = ({ settings }) => {
    const { data: videos, isLoading } = useCollection<Video>('videos', { field: 'order', direction: 'asc' });
    const [selectedVideo, setSelectedVideo] = useState<Video | null>(null);

    useSEO({
        title: `Videos | ${settings?.companyName || 'ARCH.'}`,
        description: `Explore our collection of promotional videos, architectural walkthroughs, and design insight stories at ${settings?.companyName || 'ARCH.'}.`,
        ogImage: settings?.openGraph?.imageUrl
    }, [settings]);

    return (
        <>
            {selectedVideo && <VideoModal video={selectedVideo} onClose={() => setSelectedVideo(null)} />}
            <div className="bg-brand-light text-brand-dark pt-32 pb-16">
                <div className="container mx-auto px-6 max-w-6xl">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight font-heading">Videos</h1>
                        <p className="mt-4 text-lg text-gray-600 font-body">
                            Explore our projects, insights, and stories through our collection of promotional videos.
                        </p>
                    </div>

                    {isLoading && <p className="text-center">Loading videos...</p>}

                    {!isLoading && videos && videos.length > 0 && (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {videos.map(video => (
                                <VideoCard key={video.id} video={video} onSelect={() => setSelectedVideo(video)} />
                            ))}
                        </div>
                    )}

                    {!isLoading && (!videos || videos.length === 0) && (
                        <p className="text-center text-gray-500 py-12">No videos have been added yet.</p>
                    )}
                </div>
            </div>
        </>
    );
};

export default VideosPage;
